import React, { Component, Fragment } from 'react';
import { withTranslation } from "react-i18next";
import Wrapper from './../../../common/component/Wrapper';
import * as Func from '../../../../../helpers/functions';
import { ListComponent, StatusComponent, FilterDropdown } from '../../../common/component/Index';
import RateCode from '../../../../../models/RateCode';
import { Icon, Menu, Tooltip } from 'antd';
import * as HMS from "../../../common/component/Index";
import { PATHS, RATECODE } from '../../../../../constants/Define';
import Dropdown from '../../../common/component/Dropdown';
import { Link } from 'react-router-dom';
import Modal from '../../../common/component/Modal';
import EllipsisText from '../../../common/component/EllipsisText';

const defaultState = {

};

const ListCols = [
    'name', 'campaign', 'surchargeCategory', 'code', 'cost', 'rounding', 
    'sellCost', 'stockAvailable', 'description', 'rateCodeProduct', 'rateCodeProducts', 'isActive',
];
const ModelFields = Object.getOwnPropertyNames(new RateCode());

class RateCodeList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: Func.getTitleTable(ListCols, ['action'], []),
            modelItem: ModelFields,
            componentTable: {
                name: {
                    key: 'name',
                    fixed: 'left',
                    width: 220,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    render: (name, record)=> name && <EllipsisText title={name} content={name} contentMaxWidth={200}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                campaign: {
                    key: 'campaign',
                    render: (text, record)=> record.campaign && record.campaign?.name,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                surchargeCategory: {
                    key: 'surchargeCategory',
                    render: (text, record)=> record.surchargeCategory && record.surchargeCategory?.name,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                code: {
                    key: 'code',
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <HMS.FilterDropdown
                            setSelectedKeys={setSelectedKeys}
                            selectedKeys={selectedKeys}
                            confirm={confirm}
                            clearFilters={clearFilters}
                        >
                        </HMS.FilterDropdown>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                },
                cost: {
                    align: "right",
                    render: (cost) => Func.formatMoney(cost)
                },
                rounding: {
                    align: "right",
                    render: (rounding) => Func.formatMoney(rounding)
                },
                sellCost: {
                    align: "right",
                    render: (sellCost) => Func.formatMoney(sellCost)
                },
                stockAvailable: {
                    align: 'right',
                    width: 150,
                },
                description: {
                    key: 'description',
                    render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={300}
                    overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                },
                rateCodeProduct: {
                    key: "rateCodeProduct",
                    align: 'center',
                    render: (text, record)=> {
                        let textProduct = record.rateCodeProducts.length;
                        return <EllipsisText title={textProduct} content={textProduct} contentMaxWidth={"auto"}
                        overlayClassName={'text-center'} overlayComponent={Tooltip} />
                    }
                },
                rateCodeProducts: {
                    key: "rateCodeProducts",
                    render: (text, record)=> {
                        let textProduct = '';
                        if(record.rateCodeProducts && record.rateCodeProducts.length > 0){
                            textProduct = record.rateCodeProducts.map((item, idx)=>{
                                return `${item.code}(${Func.formatMoney(item.cost || 0)})`
                            }).join(' - ')
                        }
                        return <EllipsisText title={textProduct} content={textProduct} contentMaxWidth={300}
                        overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
                    }
                },
                isActive: {
                    key: 'isActive',
                    render: (isActive) => (
                        <StatusComponent color={isActive ? 'green' : 'red'}
                            label={isActive ? this.props.t('item.ratecode.active') : this.props.t('item.ratecode.deactive')} />
                    ),
                    filters: [
                        { value: true, text: this.props.t('item.ratecode.active') },
                        { value: false, text: this.props.t('item.ratecode.deactive') }
                    ],
                    filterMultiple: false,
                },
                action: {
                    width: 80,
                    align: 'center',
                    key: 'action',
                    fixed: 'right',
                    render: (text, record) => this.renderEditComponent(record),
                }
            },
        };
    }

    renderEditComponent(item) {
        const { t, permisions } = this.props;
        const isVinwonderType = (item.productTypes || []).includes(RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.value);
        const removeAgent = () => {
            return this.props.onLockRateCode && this.props.onLockRateCode(item)
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(item.isActive ? t('item.ratecode.lock') : t('item.ratecode.unLock'), t(`item.ratecode.name`)),
                content: item.name,
                okText: item.isActive ? t(`action.lockItem`) : t(`action.unlockItem`),
                cancelText: t(`action.cancel`),
                onOk: removeAgent,
            });
        };
        return (
            <Fragment>
                <Dropdown overlay={
                    <Menu className="action-menu">
                        {
                            permisions && permisions.allowUpdate &&
                            <Menu.Item>
                                <Link to={Func.getPathWithParams(PATHS.RATECODE.DETAIL.path, { id: item.id })} className={`mr-2`}>
                                    <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                                </Link>
                            </Menu.Item>
                        }
                        {/* {
                            permisions && permisions.allowUpdate && !isVinwonderType &&
                            <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.RATECODE.USAGE_PLAN.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="eye" className="fs20 mr-1" /> {t(`action.usageSchdule`)}
                            </Link>
                            </Menu.Item>

                        } */}
                        {
                            permisions && permisions.allowUpdate  &&
                            <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.RATECODE.USAGE_PLAN.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="eye" className="fs20 mr-1" /> {t(`action.usageSchdule`)}
                            </Link>
                            </Menu.Item>

                        }
                        {
                            permisions && permisions.allowDelete &&
                            <Menu.Item onClick={onRemove}><Icon type={ item.isActive ? "lock" : "unlock" } className="fs20 mr-1" />{item.isActive ? t(`action.lockItem`) : t(`action.unlockItem`)}</Menu.Item>
                        }
                    </Menu>
                }>
                    <Icon type="more" className="fs20 cursorPointer" />
                </Dropdown>
            </Fragment>
        )
    }

    
    render(){
        const { t, loading, pagination, rateCodes } = this.props;
        const { titleItemTable, modelItem, componentTable } = this.state;
        return(
            <Wrapper className="mt-2">
                <ListComponent
                    tableKey="ticket-list"
                    classParent="m-0 p-0 col-md-12" classChildren="p-0"
                    marginTop={'0'} marginBottom={'0'}
                    loading={{ spinning: loading, size: 'large' }}
                    scroll={{x: 2000}}
                    rowKey={(record, k) => record.id ? record.id : k}
                    dataSource={Func.getDataSource(rateCodes || [], modelItem)}
                    columns={Func.columnsTable({
                        titleTable: titleItemTable,
                        component: componentTable,
                        itemName: 'ratecode'
                    })}
                    pagination={{ total: pagination.totalCount, totalPage: pagination.totalPage, defaultCurrent: pagination.defaultCurrent, pageSize: pagination.pageSize }}
                    onChange={this.props.onChange}
                    componentTableList={{}}
                />
            </Wrapper>
        )
    
    }
}

export default withTranslation()(RateCodeList);
